import React from 'react';

import { getDeviceId, getSessionId, getUserId } from '@amplitude/analytics-browser';
import IntercomAPI from '@intercom/messenger-js-sdk';

import { Button } from 'wanderu-components';
import appSettings from 'wanderu-config';
import { localize } from 'wanderu-i18n';
import { SnowplowService } from 'wanderu-service-analytics';

import intercomIcon from 'wanderu-assets/images/intercom.svg';

import styles from './Intercom.scss';

import type { TFunction } from 'i18next';

const SDK_CSS_CLASS = 'intercom-launcher';

interface IntercomProps {
    children?: React.ReactNode;
    imageClassName?: string;
    onClick?: (e: React.MouseEvent) => void;
    t: TFunction;
    unstyled?: boolean;
    wrapperClassName?: string;
}

function Intercom(props: IntercomProps) {
    const {
        children,
        imageClassName = '',
        onClick = () => undefined,
        t,
        unstyled = true,
        wrapperClassName = '',
    } = props;

    const handleClick = (e: React.MouseEvent) => {
        SnowplowService.fireStructuredEvent({
            action: 'click',
            category: 'customer_service_chat',
            label: '',
        });
        onClick(e);
    };

    const amplitudeDeviceId = getDeviceId();
    const amplitudeSessionId = getSessionId();
    const amplitudeUrl = amplitudeDeviceId && `https://app.amplitude.com/analytics/wanderu/users?search=${amplitudeDeviceId}&property=device_id&searchType=search`;
    const amplitudeUserId = getUserId();

    IntercomAPI({
        amplitudeDeviceId,
        amplitudeSessionId,
        amplitudeUrl,
        amplitudeUserId,
        app_id: appSettings.config.intercom.appId,
        custom_launcher_selector: `.${SDK_CSS_CLASS}`,
        hide_default_launcher: true,
    });

    return (
        <>
            <Button
                className={`${styles.intercomWidget} ${wrapperClassName} ${SDK_CSS_CLASS}`}
                onClick={handleClick}
                unstyled={unstyled}
            >
                <img
                    alt={t('contact-support')}
                    className={`${styles.intercomGraphic} ${imageClassName}`}
                    src={intercomIcon}
                />
                {children}
            </Button>
        </>
    );
}

export { Intercom };
export default localize(Intercom, ['t'], 'baseApp');
